import { useBreakpoint } from "src/components/util/useBreakpoint";

interface Props {
  xl?: boolean;
  lg?: boolean;
  md?: boolean;
  sm?: boolean;
  xs?: boolean;
  children: any;
}

const Show = ({ children, ...breakpointProps }: Props) => {
  const breakpoint = useBreakpoint();
  if (!breakpointProps[breakpoint]) {
    return null;
  }

  return children;
};

const Hide = ({ children, ...breakpointProps }: Props) => {
  const breakpoint = useBreakpoint();
  if (breakpointProps[breakpoint]) {
    return null;
  }

  return children;
};

export const mobileSizeProps = { xs: true, sm: true };
export const desktopSizeProps = { md: true, lg: true, xl: true };

export const Visibility = {
  Show,
  Hide,
};
